import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';

var ContextMenuContainer = function (_PureComponent) {
  _inherits(ContextMenuContainer, _PureComponent);

  function ContextMenuContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContextMenuContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContextMenuContainer.__proto__ || Object.getPrototypeOf(ContextMenuContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: null
    }, _this.registerHandlers = function () {
      document.addEventListener('mousedown', _this.handleOutsideClick);
      document.addEventListener('touchstart', _this.handleOutsideClick);
      document.addEventListener('scroll', _this.closeMenu);
      document.addEventListener('contextmenu', _this.closeMenu);
      window.addEventListener('resize', _this.closeMenu);
    }, _this.unregisterHandlers = function () {
      document.removeEventListener('mousedown', _this.handleOutsideClick);
      document.removeEventListener('touchstart', _this.handleOutsideClick);
      document.removeEventListener('scroll', _this.closeMenu);
      document.removeEventListener('contextmenu', _this.closeMenu);
      window.removeEventListener('resize', _this.closeMenu);
    }, _this.handleOutsideClick = function (e) {
      if (!_this.contextMenu.contains(e.target)) {
        _this.closeMenu();
      }
    }, _this.setRef = function (ref) {
      _this.contextMenu = ref;
    }, _this.onContextMenu = function (e) {
      _this.registerHandlers();
      e.preventDefault();
      e.stopPropagation();
      _this.setState({
        isActive: {
          clientX: e.nativeEvent.clientX,
          clientY: e.nativeEvent.clientY
        }
      });
      return false;
    }, _this.closeMenu = function () {
      _this.setState({
        isActive: null
      });
      _this.unregisterHandlers();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContextMenuContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unregisterHandlers();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children(this.setRef, this.onContextMenu, this.closeMenu, this.state.isActive);
    }
  }]);

  return ContextMenuContainer;
}(PureComponent);

ContextMenuContainer.propTypes = {
  children: PropTypes.func.isRequired
};
export default ContextMenuContainer;
//# sourceMappingURL=ContextMenuContainer.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ContextMenu/ContextMenuContainer.js
// module id = 818
// module chunks = 0